import { render, staticRenderFns } from "./Banners.vue?vue&type=template&id=8aa134b6&scoped=true&"
import script from "./Banners.vue?vue&type=script&lang=ts&"
export * from "./Banners.vue?vue&type=script&lang=ts&"
import style0 from "./Banners.vue?vue&type=style&index=0&id=8aa134b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa134b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VImg,VProgressCircular})
